import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import { Content } from '../Content';
import getContentfulField from './getContentfulField';
import { useClassName } from 'common/hooks';
import { LazyMarkdownRenderer } from 'common/lazy';

import './markdown.less';
import { STANDARD_EVENTS } from 'utils/analytics/trackV2';

const ContentfulMarkdown = ({ field, handleTrack, ...rest }) => {
  const className = useClassName('Markdown');
  const contentRef = useRef(null);
  const content = getContentfulField(field);

  useEffect(() => {
    const container = contentRef.current;
    if (!container || !handleTrack) return;
    const clickHandler = (e) => {
      const link = e.target.closest('a');
      if (!link) return;
      const linkText = link.textContent?.trim() || '';
      const href = link.getAttribute('href') || '';
      handleTrack?.({
        event: STANDARD_EVENTS.click,
        params: {
          label: linkText,
          destination_url: href,
          cta_type: 'link',
        },
      });
    };
    container.addEventListener('click', clickHandler);
    return () => {
      container.removeEventListener('click', clickHandler);
    };
  }, [handleTrack]);

  return (
    <Content ref={contentRef} className={className('container')} {...rest}>
      <LazyMarkdownRenderer
        markdown={content || ''}
        options={{ breaks: true, html: true }}
      />
    </Content>
  );
};

ContentfulMarkdown.propTypes = {
  field: PropTypes.object.isRequired,
};

export default ContentfulMarkdown;
